// A simple utility to extract keywords from reflection text
// We use a predefined stopword list to filter out common words
const STOP_WORDS = new Set([
  'a', 'an', 'and', 'are', 'as', 'at', 'be', 'but', 'by', 'for', 'if', 'in', 'into', 'is', 'it', 'no', 'not', 'of', 'on', 'or', 'such', 'that', 'the', 'their', 'then', 'there', 'these', 'they', 'this', 'to', 'was', 'will', 'with', 'i', 'my', 'me', 'we', 'us', 'you', 'your', 'he', 'she', 'him', 'her', 'it', 'they', 'them', 'what', 'which', 'who', 'whom', 'this', 'that', 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'would', 'should', 'could', 'ought', 'i\'m', 'you\'re', 'he\'s', 'she\'s', 'it\'s', 'we\'re', 'they\'re', 'i\'ve', 'you\'ve', 'we\'ve', 'they\'ve', 'i\'d', 'you\'d', 'he\'d', 'she\'d', 'we\'d', 'they\'d', 'i\'ll', 'you\'ll', 'he\'ll', 'she\'ll', 'we\'ll', 'they\'ll', 'isn\'t', 'aren\'t', 'wasn\'t', 'weren\'t', 'hasn\'t', 'haven\'t', 'hadn\'t', 'doesn\'t', 'don\'t', 'didn\'t', 'won\'t', 'wouldn\'t', 'shan\'t', 'shouldn\'t', 'can\'t', 'cannot', 'couldn\'t', 'mustn\'t', 'let\'s', 'that\'s', 'who\'s', 'what\'s', 'here\'s', 'there\'s', 'when\'s', 'where\'s', 'why\'s', 'how\'s', 'so', 'just', 'like', 'really', 'very', 'much', 'too', 'too', 'also', 'well', 'about', 'out', 'up', 'down', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', 'should', 'now', 'feeling', 'feel', 'today', 'think', 'thought', 'going', "it's", "i'm"
]);

export function analyzeReflection(text) {
  if (!text || typeof text !== 'string') {
    return ['reflection', 'mind', 'wellness'];
  }

  // 1. Clean the text: lowercase, remove punctuation, split into words
  const words = text
    .toLowerCase()
    .replace(/[^\w\s]/g, '')
    .split(/\s+/)
    .filter(word => word.length > 2); // Exclude very short words
    
  // 2. Filter out stop words and count frequencies
  const frequencies = {};
  words.forEach(word => {
    if (!STOP_WORDS.has(word)) {
      frequencies[word] = (frequencies[word] || 0) + 1;
    }
  });

  // 3. Sort by frequency and take top 3
  const sortedKeywords = Object.entries(frequencies)
    .sort((a, b) => b[1] - a[1])
    .map(([word]) => word);

  // Fallbacks if not enough words
  const fallbacks = ['reflection', 'mindful', 'journey', 'growth', 'balance'];
  
  const result = [];
  for (let i = 0; i < 3; i++) {
    if (sortedKeywords[i]) {
      result.push(sortedKeywords[i]);
    } else {
      result.push(fallbacks[i % fallbacks.length]);
    }
  }

  return result;
}
